__turbopack_context__.v({
  "card": "ArvwnG_card",
  "sticky": "ArvwnG_sticky",
});
